import type { PrivateEventCrewView } from '../../api/privateEvents';

import NotRecordedPill from './NotRecordedPill';
import { eventLocation, LOCATION_TBD } from './privateEventDisplay';

/** Where the event is, honestly across its states: a place, undecided, or
 *  never recorded by the import. */
export default function PrivateEventLocationValue({ event }: { event: PrivateEventCrewView }) {
  if (event.locationKind === 'tbd') {
    return <span style={{ fontStyle: 'italic', color: 'var(--nb-muted)' }}>{LOCATION_TBD}</span>;
  }
  const location = eventLocation(event);
  if (!location) {
    return event.migrated ? (
      <NotRecordedPill field="Location" />
    ) : (
      <span style={{ fontStyle: 'italic', color: 'var(--nb-faint)' }}>Not set</span>
    );
  }
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 1, minWidth: 0 }}>
      <span style={{ fontWeight: 600 }}>{location.primary}</span>
      {location.subline && (
        <span style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>{location.subline}</span>
      )}
    </span>
  );
}
